import { forwardRef, ForwardRefRenderFunction, useEffect } from "react";
//#region types
import { BoardMemberFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { WintFormConnect } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { EditableTable, EmailInput, FormFieldLayout, useWintForm, WintForm } from "components/common/wintForms";
import { BoardMemberDetailsToDoFormProps } from "models/propTypes/boardMemberPropTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import BoardMemberDisplayComponent from "./boardMemberDisplayComponent";
//#endregion

const BoardMemberDetailsToDoForm: ForwardRefRenderFunction<FormHandles, BoardMemberDetailsToDoFormProps> = (
  props,
  ref
) => {
  const { defaultValues, validationSchema, handleSubmit, onFormUpdate } = props;

  const { wintFormProps, connect, values, formState } = useWintForm<BoardMemberFormTypes.BoardMembersDisplay>({
    formRef: ref,
    handleSubmit: handleSubmit,
    defaultValues: defaultValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
  });

  useEffect(() => {
    if (onFormUpdate && values) {
      onFormUpdate(values, formState.isValid);
    }
  }, [formState.isValid, onFormUpdate, values]);

  return (
    <WintForm {...wintFormProps}>
      <FormFieldLayout {...connect("boardMembers")} direction="vertical">
        <EditableTable<BoardMemberFormTypes.BoardMemberDisplay>
          connect={connect as WintFormConnect<any>}
          name={"boardMembers"}
          value={values.boardMembers ?? []}
          fields={{
            boardMember: {
              Component: BoardMemberDisplayComponent,
              widthColumnCount: 5,
            },
            mail: {
              Component: EmailInput,
              extraProps: {
                label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Email),
              },
            },
          }}
          idField="socialSecurityNumber"
          isCompactTable
          hideActions
          hideActionsCell
          defaultRow={{}}
        />
      </FormFieldLayout>
    </WintForm>
  );
};

export default forwardRef(BoardMemberDetailsToDoForm);
